module.exports = __webpack_public_path__ + "static/media/message.cbace9af.svg";